import { useEffect, useReducer } from 'react'
import { AnyAction } from 'redux'
import {
  GET_BRAND_PAGES,
  ADD_BRANDLICENCE,
  GET_BRANDLICENCE,
  UPDATE_BRANDLICENCE,
} from '../../api/MaterialApi'
import {
  GetLocalStorage,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { fileFile } from '../../modules/goodsdetailmodules/uploadfilesBrand'
import { history, useTypedSelector } from '../../redux/store'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import { delTabsAction } from '../../modules/authtoken'
import { useDispatch } from 'react-redux'
import { tableresultData } from '../../components/AddBrandTable'
import { message, Form } from 'antd'
// action 类型定义
const BRANDADD_ACTION_TYPE = {
  VISIBLE: 'BRANDADD_ACTION/VISIBLE', // 弹窗
  CHANGE_PIC: 'BRANDADD_ACTION/CHANGE_PIC',
  LICENCE_INFO: 'BRANDADD_ACTION/LICENCE_INFO',
  CHANGE_MANPIC: 'BRANDADD_ACTION/CHANGE_MANPIC',
  CHANGE_MODAL: 'BRANDADD_ACTION/CHANGE_MODAL',
  SET_LOADING: 'BRANDADD_ACTION/SET_LOADING',
  SET_KEYNAME: 'BRANDADD_ACTION/SET_KEYNAME',
  SET_DATALIST: 'BRANDADD_ACTION/SET_DATALIST',
  SET_DATA: 'BRANDADD_ACTION/SET_DATA',
  SET_BRANDDATA: 'BRANDADD_ACTION/SET_BRANDDATA',
}
interface CooperationState {
  visible: boolean
  fileList: fileFile[]
  dataList: tableresultData
  dataType: string
  uploadParams: { code: string; type: string }
  licenceInfo: {
    baseUrl: string
    managementLicenceState: string
    managementLicenceUrl: string
    productionLicenceState: string
    productionLicenceUrl: string
  }
  productCode: any
  keyName: string // 搜索数据
  dataSource: tableresultData // 数据源
  loading: boolean
  brandList: any[]
}
const defaultState: CooperationState = {
  visible: false,
  fileList: [], // 预览图
  uploadParams: {
    code: GetLocalStorage('SUPPLIER_CODE'),
    type: 'brand',
  },
  licenceInfo: {
    baseUrl: '',
    managementLicenceState: '',
    managementLicenceUrl: '',
    productionLicenceState: '',
    productionLicenceUrl: '',
  },
  keyName: '',
  productCode: {},
  dataList: { current: 1, total: 0, data: [] },
  dataType: 'brand',
  dataSource: {
    current: 1,
    total: 0,
    data: [],
  },
  loading: false,
  brandList: [],
}
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case BRANDADD_ACTION_TYPE.VISIBLE:
      arr.visible = action.value
      return arr
    case BRANDADD_ACTION_TYPE.CHANGE_PIC:
      arr.fileList = action.value
      return arr
    case BRANDADD_ACTION_TYPE.LICENCE_INFO:
      arr.licenceInfo = action.value
      return arr
    case BRANDADD_ACTION_TYPE.CHANGE_MODAL:
      arr.visible = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_KEYNAME:
      arr.keyName = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_DATALIST:
      arr.dataList = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_BRANDDATA:
      arr.brandList = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}
const setSwitchAction = (params: boolean) => ({
  type: BRANDADD_ACTION_TYPE.CHANGE_MODAL,
  value: params,
})
const setLoadingAction = (param: boolean) => ({
  type: BRANDADD_ACTION_TYPE.SET_LOADING,
  value: param,
})

const setKeyNameAction = (param: string) => ({
  type: BRANDADD_ACTION_TYPE.SET_KEYNAME,
  value: param,
})

const setDataFilterAction = (param: tableresultData) => ({
  type: BRANDADD_ACTION_TYPE.SET_DATALIST,
  value: param,
})

const setDataAction = (param: tableresultData) => ({
  type: BRANDADD_ACTION_TYPE.SET_DATA,
  value: param,
})

const setBrandDataAction = (param: any[]) => ({
  type: BRANDADD_ACTION_TYPE.SET_BRANDDATA,
  value: param,
})

const setBrandUploadDataAction = (param: any[]) => ({
  type: BRANDADD_ACTION_TYPE.CHANGE_PIC,
  value: param,
})

const useAddBrandHooks = () => {
  const [hookState, dispatch] = useReducer(reducer, defaultState)
  const [form] = Form.useForm()
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const location = useLocation()
  const dispatchRedux = useDispatch()
  const { pathname, state } = location
  const {
    fileList,
    productCode,
    uploadParams,
    visible,
    dataList,
    keyName,
    loading,
    brandList,
  } = hookState
  useEffect(() => {
    dispatch(setBrandUploadDataAction([]))
    getLicence(state)
    // eslint-disable-next-line
  }, [])

  const getLicence = async (state: any) => {
    if (state) {
      const res = await GET_BRANDLICENCE({ id: state.id })
      if (isResponseCodeSuccess(res.code)) {
        // 类型
        form.setFieldsValue(res.data)
        // 品牌
        res.data.brands.forEach((item: any) => {
          item.brandCnName = item.brandName
        })
        dispatch(setBrandDataAction(res.data.brands))
        // 授权书
        const arr: any[] = []
        res.data.fileList.forEach((item: any) => {
          arr.push({
            baseUrl: GetLocalStorage('BASEURL'),
            fileName: item.fileName,
            url: item.licenceUrl,
            fileId: res.data.fileId,
          })
        })
        dispatch(setBrandUploadDataAction(arr))
      } else {
        message.warning(`${res.msg}`)
      }
    }
  }
  const updataFile = (img: fileFile[]) => {
    const imgData = {
      url: `${img[0].url}`,
      fileName: `${img[0].fileName}`,
      baseUrl: `${GetLocalStorage('BASEURL')}`,
    }
    fileList.push(imgData)
    dispatch(setBrandUploadDataAction(fileList))
  }
  // 删除附件
  const deleteFile = (file: fileFile[]) => {
    dispatch(setBrandUploadDataAction(file))
  }
  // 刷新
  const onRefresh = () => {
    getLicence(state)
  }
  // 关闭标签页
  const closeTab = () => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = url
    }
    // 删除标签 跳转前一个标签页
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: hookState, // 当前状态
        formData: {
          consignorName: undefined,
          isAutoCompleteAllocate: undefined,
          isDefaultSchema: undefined,
          name: undefined,
          orgList: undefined,
          shipperCode: undefined,
          sort: undefined,
        },
      },
    })
    dispatchRedux(action)
    dispatchRedux(delTabsAction(delkey))
    history.replace(newurl)
  }
  const saveFrom = async () => {
    const formData = await form.validateFields()
    const brandNameParamDTOS: {
      brandNameCn: string
      brandNameEn: string
      brandMdmId: string
    }[] = []
    const ids: string[] = []
    brandList.forEach((item) => {
      brandNameParamDTOS.push({
        brandNameCn: item.brandCnName,
        brandNameEn: item.brandEnName,
        brandMdmId: item.brandMdmId,
      })
      ids.push(item.brandId)
    })
    if (!fileList.length) {
      return message.warning('请上传授权书！')
    }
    if (!brandList.length) {
      return message.warning('请选择授权品牌！')
    }
    if (pathname !== '/srm/updateBrandAuthority') {
      const arr: any[] = []
      fileList.forEach((item: any) => {
        arr.push({
          fileName: item.fileName,
          licenceUrl: item.url,
        })
      })
      const params = {
        fileAddParamList: arr,
        supplierId: getSupplierId(),
        // brands: ids.join(),
        type: formData.type,
        brandNameParamDTOS,
      }
      const res = await ADD_BRANDLICENCE({ ...params })
      if (isResponseCodeSuccess(res.code)) {
        message.success('新增成功！')
      } else {
        message.warning(`${res.msg}`)
      }
      closeTab()
    } else {
      const arr: any[] = []
      fileList.forEach((item: any) => {
        arr.push({
          fileName: item.fileName,
          licenceUrl: item.url,
        })
      })
      const params = {
        fileAddParamList: arr,
        supplierId: getSupplierId(),
        fileId: fileList[0].fileId,
        brands: ids.join(),
        type: formData.type,
      }
      const res = await UPDATE_BRANDLICENCE({ ...params })
      if (isResponseCodeSuccess(res.code)) {
        message.success('修改成功！')
      } else {
        message.warning(`${res.msg}`)
      }
      closeTab()
    }
  }
  // 删除品牌
  const onClickdel = (e: number) => {
    const arr = brandList
    arr.splice(e, 1)
    dispatch(setBrandDataAction(arr))
  }
  // 点击输入框
  const onClickInput = async () => {
    //  显示弹窗 loading 设置当前操作类型
    dispatch(setSwitchAction(true))
    dispatch(setLoadingAction(true))
    let resData: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    resData = await getBrandData(1)
    // // 存原始数据
    dispatch(setDataAction(resData))
    // // 设置过滤数据
    dispatch(setDataFilterAction(resData))
    // // loading结束
    dispatch(setLoadingAction(false))
  }
  // 获取品牌数据
  const getBrandData = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    dispatch(setLoadingAction(true))
    const resData: any = await GET_BRAND_PAGES({
      // isDisable: '0',
      pageNo: page.toString(), // 页码
      pageSize: '10', // 每页条数
      supplierId: getSupplierId(),
      brandName: str,
      // key: str, //筛选条件
      // brandToCate: false,
    })
    if (resData.code === 0) {
      const data = resData.data.content
      const total = resData.data.totalCount
      const current = resData.data.pageNo
      const arr = data.map(
        (item: {
          code: string
          brandEnName: string
          brandCnName: string
          brandId: string
          isSale: string
          logo: string
          brandMdmId: string
        }) => ({
          brandMdmId: item.brandMdmId,
          brandCnName: item.brandCnName,
          brandEnName: item.brandEnName,
          brandId: item.brandId || Math.random().toString(36).substr(2),
          code: item.code,
          brandIsSale: item.isSale,
          logo: item.logo,
        }),
      )
      dispatch(setLoadingAction(false))
      return {
        current: current,
        total: total,
        data: arr,
      }
    }
    dispatch(setLoadingAction(false))
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }
  // 关闭弹窗
  const onCancel = () => {
    const action = setSwitchAction(false)
    dispatch(action)
    dispatch(setKeyNameAction(''))
  }
  // 搜索数据
  const onSearchData = async (e: string) => {
    // 记录搜索条件
    dispatch(setKeyNameAction(e))
    const data = await getBrandData(1, e)
    dispatch(setDataFilterAction(data))
  }
  // 分页
  const onChangePage = async (page: number) => {
    //   loading
    dispatch(setLoadingAction(true))
    let resData: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    resData = await getBrandData(page, keyName)
    // 存原始数据
    dispatch(setDataAction(resData))
    // 设置过滤数据
    dispatch(setDataFilterAction(resData))
    // loading结束
    dispatch(setLoadingAction(false))
  }

  // 处理勾选数据
  const changeBrandIds = (arr: any[]) => {
    const data: any[] = brandList.concat(arr)
    const brandData: any = []
    const obj: any = {}
    for (let i = 0; i < data.length; i++) {
      if (!obj[data[i].brandId]) {
        brandData.push(data[i])
        obj[data[i].brandId] = true
      }
    }
    dispatch(setBrandDataAction(brandData))
  }

  return {
    updataFile,
    form,
    onRefresh,
    closeTab,
    onClickdel,
    onClickInput,
    fileList,
    productCode,
    uploadParams,
    visible,
    onCancel,
    onSearchData,
    dataList,
    onChangePage,
    loading,
    changeBrandIds,
    brandList,
    saveFrom,
    deleteFile,
  }
}

export default useAddBrandHooks
import { useEffect, useReducer } from 'react'
import { AnyAction } from 'redux'
import {
  GET_BRAND_PAGES,
  ADD_BRANDLICENCE,
  GET_BRANDLICENCE,
  UPDATE_BRANDLICENCE,
} from '../../api/MaterialApi'
import {
  GetLocalStorage,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { fileFile } from '../../modules/goodsdetailmodules/uploadfilesBrand'
import { history, useTypedSelector } from '../../redux/store'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import { delTabsAction } from '../../modules/authtoken'
import { useDispatch } from 'react-redux'
import { tableresultData } from '../../components/AddBrandTable'
import { message, Form } from 'antd'
// action 类型定义
const BRANDADD_ACTION_TYPE = {
  VISIBLE: 'BRANDADD_ACTION/VISIBLE', // 弹窗
  CHANGE_PIC: 'BRANDADD_ACTION/CHANGE_PIC',
  LICENCE_INFO: 'BRANDADD_ACTION/LICENCE_INFO',
  CHANGE_MANPIC: 'BRANDADD_ACTION/CHANGE_MANPIC',
  CHANGE_MODAL: 'BRANDADD_ACTION/CHANGE_MODAL',
  SET_LOADING: 'BRANDADD_ACTION/SET_LOADING',
  SET_KEYNAME: 'BRANDADD_ACTION/SET_KEYNAME',
  SET_DATALIST: 'BRANDADD_ACTION/SET_DATALIST',
  SET_DATA: 'BRANDADD_ACTION/SET_DATA',
  SET_BRANDDATA: 'BRANDADD_ACTION/SET_BRANDDATA',
}
interface CooperationState {
  visible: boolean
  fileList: fileFile[]
  dataList: tableresultData
  dataType: string
  uploadParams: { code: string; type: string }
  licenceInfo: {
    baseUrl: string
    managementLicenceState: string
    managementLicenceUrl: string
    productionLicenceState: string
    productionLicenceUrl: string
  }
  productCode: any
  keyName: string // 搜索数据
  dataSource: tableresultData // 数据源
  loading: boolean
  brandList: any[]
}
const defaultState: CooperationState = {
  visible: false,
  fileList: [], // 预览图
  uploadParams: {
    code: GetLocalStorage('SUPPLIER_CODE'),
    type: 'brand',
  },
  licenceInfo: {
    baseUrl: '',
    managementLicenceState: '',
    managementLicenceUrl: '',
    productionLicenceState: '',
    productionLicenceUrl: '',
  },
  keyName: '',
  productCode: {},
  dataList: { current: 1, total: 0, data: [] },
  dataType: 'brand',
  dataSource: {
    current: 1,
    total: 0,
    data: [],
  },
  loading: false,
  brandList: [],
}
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case BRANDADD_ACTION_TYPE.VISIBLE:
      arr.visible = action.value
      return arr
    case BRANDADD_ACTION_TYPE.CHANGE_PIC:
      arr.fileList = action.value
      return arr
    case BRANDADD_ACTION_TYPE.LICENCE_INFO:
      arr.licenceInfo = action.value
      return arr
    case BRANDADD_ACTION_TYPE.CHANGE_MODAL:
      arr.visible = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_KEYNAME:
      arr.keyName = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_DATALIST:
      arr.dataList = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_BRANDDATA:
      arr.brandList = action.value
      return arr
    case BRANDADD_ACTION_TYPE.SET_LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}
const setSwitchAction = (params: boolean) => ({
  type: BRANDADD_ACTION_TYPE.CHANGE_MODAL,
  value: params,
})
const setLoadingAction = (param: boolean) => ({
  type: BRANDADD_ACTION_TYPE.SET_LOADING,
  value: param,
})

const setKeyNameAction = (param: string) => ({
  type: BRANDADD_ACTION_TYPE.SET_KEYNAME,
  value: param,
})

const setDataFilterAction = (param: tableresultData) => ({
  type: BRANDADD_ACTION_TYPE.SET_DATALIST,
  value: param,
})

const setDataAction = (param: tableresultData) => ({
  type: BRANDADD_ACTION_TYPE.SET_DATA,
  value: param,
})

const setBrandDataAction = (param: any[]) => ({
  type: BRANDADD_ACTION_TYPE.SET_BRANDDATA,
  value: param,
})

const setBrandUploadDataAction = (param: any[]) => ({
  type: BRANDADD_ACTION_TYPE.CHANGE_PIC,
  value: param,
})

const useAddBrandHooks = () => {
  const [hookState, dispatch] = useReducer(reducer, defaultState)
  const [form] = Form.useForm()
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const location = useLocation()
  const dispatchRedux = useDispatch()
  const { pathname, state } = location
  const {
    fileList,
    productCode,
    uploadParams,
    visible,
    dataList,
    keyName,
    loading,
    brandList,
  } = hookState
  useEffect(() => {
    dispatch(setBrandUploadDataAction([]))
    getLicence(state)
    // eslint-disable-next-line
  }, [])

  const getLicence = async (state: any) => {
    if (state) {
      const res = await GET_BRANDLICENCE({ id: state.id })
      if (isResponseCodeSuccess(res.code)) {
        // 类型
        form.setFieldsValue(res.data)
        // 品牌
        res.data.brands.forEach((item: any) => {
          item.brandCnName = item.brandName
        })
        dispatch(setBrandDataAction(res.data.brands))
        // 授权书
        const arr: any[] = []
        res.data.fileList.forEach((item: any) => {
          arr.push({
            baseUrl: GetLocalStorage('BASEURL'),
            fileName: item.fileName,
            url: item.licenceUrl,
            fileId: res.data.fileId,
          })
        })
        dispatch(setBrandUploadDataAction(arr))
      } else {
        message.warning(`${res.msg}`)
      }
    }
  }
  const updataFile = (img: fileFile[]) => {
    const imgData = {
      url: `${img[0].url}`,
      fileName: `${img[0].fileName}`,
      baseUrl: `${GetLocalStorage('BASEURL')}`,
    }
    fileList.push(imgData)
    dispatch(setBrandUploadDataAction(fileList))
  }
  // 删除附件
  const deleteFile = (file: fileFile[]) => {
    dispatch(setBrandUploadDataAction(file))
  }
  // 刷新
  const onRefresh = () => {
    getLicence(state)
  }
  // 关闭标签页
  const closeTab = () => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = url
    }
    // 删除标签 跳转前一个标签页
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: hookState, // 当前状态
        formData: {
          consignorName: undefined,
          isAutoCompleteAllocate: undefined,
          isDefaultSchema: undefined,
          name: undefined,
          orgList: undefined,
          shipperCode: undefined,
          sort: undefined,
        },
      },
    })
    dispatchRedux(action)
    dispatchRedux(delTabsAction(delkey))
    history.replace(newurl)
  }
  const saveFrom = async () => {
    const formData = await form.validateFields()
    const brandNameParamDTOS: {
      brandNameCn: string
      brandNameEn: string
      brandMdmId: string
    }[] = []
    const ids: string[] = []
    brandList.forEach((item) => {
      brandNameParamDTOS.push({
        brandNameCn: item.brandCnName,
        brandNameEn: item.brandEnName,
        brandMdmId: item.brandMdmId,
      })
      ids.push(item.brandId)
    })
    if (!fileList.length) {
      return message.warning('请上传授权书！')
    }
    if (!brandList.length) {
      return message.warning('请选择授权品牌！')
    }
    if (pathname !== '/srm/updateBrandAuthority') {
      const arr: any[] = []
      fileList.forEach((item: any) => {
        arr.push({
          fileName: item.fileName,
          licenceUrl: item.url,
        })
      })
      const params = {
        fileAddParamList: arr,
        supplierId: getSupplierId(),
        // brands: ids.join(),
        type: formData.type,
        brandNameParamDTOS,
      }
      const res = await ADD_BRANDLICENCE({ ...params })
      if (isResponseCodeSuccess(res.code)) {
        message.success('新增成功！')
      } else {
        message.warning(`${res.msg}`)
      }
      closeTab()
    } else {
      const arr: any[] = []
      fileList.forEach((item: any) => {
        arr.push({
          fileName: item.fileName,
          licenceUrl: item.url,
        })
      })
      const params = {
        fileAddParamList: arr,
        supplierId: getSupplierId(),
        fileId: fileList[0].fileId,
        brands: ids.join(),
        type: formData.type,
      }
      const res = await UPDATE_BRANDLICENCE({ ...params })
      if (isResponseCodeSuccess(res.code)) {
        message.success('修改成功！')
      } else {
        message.warning(`${res.msg}`)
      }
      closeTab()
    }
  }
  // 删除品牌
  const onClickdel = (e: number) => {
    const arr = brandList
    arr.splice(e, 1)
    dispatch(setBrandDataAction(arr))
  }
  // 点击输入框
  const onClickInput = async () => {
    //  显示弹窗 loading 设置当前操作类型
    dispatch(setSwitchAction(true))
    dispatch(setLoadingAction(true))
    let resData: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    resData = await getBrandData(1)
    // // 存原始数据
    dispatch(setDataAction(resData))
    // // 设置过滤数据
    dispatch(setDataFilterAction(resData))
    // // loading结束
    dispatch(setLoadingAction(false))
  }
  // 获取品牌数据
  const getBrandData = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    dispatch(setLoadingAction(true))
    const resData: any = await GET_BRAND_PAGES({
      // isDisable: '0',
      pageNo: page.toString(), // 页码
      pageSize: '10', // 每页条数
      supplierId: getSupplierId(),
      brandName: str,
      // key: str, //筛选条件
      // brandToCate: false,
    })
    if (resData.code === 0) {
      const data = resData.data.content
      const total = resData.data.totalCount
      const current = resData.data.pageNo
      const arr = data.map(
        (item: {
          code: string
          brandEnName: string
          brandCnName: string
          brandId: string
          isSale: string
          logo: string
          brandMdmId: string
        }) => ({
          brandMdmId: item.brandMdmId,
          brandCnName: item.brandCnName,
          brandEnName: item.brandEnName,
          brandId: item.brandId || Math.random().toString(36).substr(2),
          code: item.code,
          brandIsSale: item.isSale,
          logo: item.logo,
        }),
      )
      dispatch(setLoadingAction(false))
      return {
        current: current,
        total: total,
        data: arr,
      }
    }
    dispatch(setLoadingAction(false))
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }
  // 关闭弹窗
  const onCancel = () => {
    const action = setSwitchAction(false)
    dispatch(action)
    dispatch(setKeyNameAction(''))
  }
  // 搜索数据
  const onSearchData = async (e: string) => {
    // 记录搜索条件
    dispatch(setKeyNameAction(e))
    const data = await getBrandData(1, e)
    dispatch(setDataFilterAction(data))
  }
  // 分页
  const onChangePage = async (page: number) => {
    //   loading
    dispatch(setLoadingAction(true))
    let resData: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    resData = await getBrandData(page, keyName)
    // 存原始数据
    dispatch(setDataAction(resData))
    // 设置过滤数据
    dispatch(setDataFilterAction(resData))
    // loading结束
    dispatch(setLoadingAction(false))
  }

  // 处理勾选数据
  const changeBrandIds = (arr: any[]) => {
    const data: any[] = brandList.concat(arr)
    const brandData: any = []
    const obj: any = {}
    for (let i = 0; i < data.length; i++) {
      if (!obj[data[i].brandId]) {
        brandData.push(data[i])
        obj[data[i].brandId] = true
      }
    }
    dispatch(setBrandDataAction(brandData))
  }

  return {
    updataFile,
    form,
    onRefresh,
    closeTab,
    onClickdel,
    onClickInput,
    fileList,
    productCode,
    uploadParams,
    visible,
    onCancel,
    onSearchData,
    dataList,
    onChangePage,
    loading,
    changeBrandIds,
    brandList,
    saveFrom,
    deleteFile,
  }
}

export default useAddBrandHooks
